import InputIcon from '@mui/icons-material/Input';
import { AppBar, Toolbar } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

import { pagePaths } from '~constants';

import { useStyles } from './style';
import TopologyIcon from '../../../assets/images/topology_logo.svg';
import { StyledButton } from '../../../components';

interface TopbarProps {
	className?: string;
}

const Topbar = (props: TopbarProps) => {
	const { className } = props;

	const { t } = useTranslation();
	const navigate = useNavigate();

	const classes = useStyles();

	const handleSignoutClick = () => {
		navigate(`/${pagePaths.AuthLogout}`);
	};

	return (
		<AppBar className={clsx(classes.root, className)}>
			<Toolbar className={classes.toolbar}>
				<RouterLink to='/'>
					<img src={TopologyIcon} width='140px' />
				</RouterLink>
				{window.location.pathname === '/auth/login' ?
					<StyledButton href='/register/start' variant='contained-secondary'>
						{t('view.login.button.contained.addorganisation')}
					</StyledButton>
				: (
					window.location.pathname === '/register/organisation' ||
					window.location.pathname === '/register/verification-status'
				) ?
					<StyledButton
						onClick={handleSignoutClick}
						startIcon={<InputIcon className={classes.logoutIcon} />}
						variant='inline-default'
					>
						{t('ui.button.inline.signout')}
					</StyledButton>
				:	null}
			</Toolbar>
		</AppBar>
	);
};

export default Topbar;
